<template>
  <div class="operation-table">
    <div class="operation-table-head">
      <van-row>
        <van-col :span="6">{{ $t("option.order_type") }}</van-col>
        <van-col :span="7">{{ $t("option.num") }}</van-col>
        <van-col :span="7" >{{ $t("option.price1") }}</van-col>
        <van-col :span="4" class="txt-right">{{
          $t("option.order_cycle")
        }}</van-col>
      </van-row>
    </div>
    <div
      class="data-box"
      v-if="list.length > 0"
    >
    <div class="operation-table-body">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-if="list && list.length > 0"
            v-model="loading"
            :finished="finished"
            :finished-text="$t('common.nomore')"
            @load="onLoad"
          >
            <div v-for="(item, index) in list" :key="index" class="item">
              <van-row>
                <van-col :span="6">
                  <span :class="item.hyzd == 1 ? 'data-up' : 'data-down'">{{
                    item.hyzd_text
                  }}</span>
                </van-col>
                <van-col :span="7">{{ item.num }}</van-col>
                <van-col :span="7">{{ item.buyprice }}</van-col>
                <van-col :span="4" class="txt-right">
                  {{ item.time }} s
                </van-col>
              </van-row>
              <van-row style="margin-top: 10px;">
                <van-col :span="12">
                  {{ $t("option.order_time") }} : {{ item.selltime }}
                </van-col>
                <van-col :span="6">
                  <span v-if="item.status == 1">
                    {{ item.count_down > 0 ? $t("option.waitfinish") : $t("option.finishing") }}
                  </span>
                  <span v-if="item.status == 2">
                    {{ $t("option.finished") }}
                  </span>
                </van-col>
                <van-col :span="6" class="txt-right">
                  <van-count-down :time="item.count_down * 1000" format="mm:ss" v-if="item.count_down > 0">
                    <template #default="timedata">
                      <span class="data-down">{{ timedata.minutes }} m</span>
                      <span class="data-down"> : </span>
                      <span class="data-down">{{ timedata.seconds  }} s</span>
                    </template>
                  </van-count-down>
                  <span v-else>--</span>
                </van-col>
              </van-row>
              
              <van-divider />
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div v-else class="data-box">
      <van-empty :description="$t('common.nodata')" />
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "InProgressOrder",
  data(){
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,
    }
  },
  mounted(){
     this.onRefresh()
  },
  methods: {
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getHyOrderList",
        data: {
          status: 1,
          page: this.page,
          limit: this.limit,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = []
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>
  
  <style>
</style>

